var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-panel mt-5"},[_c('product-form',{attrs:{"product":_vm.product,"materials":_vm.materials,"edges":_vm.edges,"screeds":_vm.screeds},on:{"on-submit":_vm.updateProduct}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }